module.exports = __webpack_public_path__ + "static/media/by-queue.5c0d4e54.svg";